import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "toggle-icon-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggle-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "toggle-line" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center py-3" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "me-2",
      src: _imports_0,
      alt: "",
      width: "160"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn navbar-toggler-humburger-icon navbar-vertical-toggle",
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "left",
        title: "Toggle Navigation",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
        "aria-label": "Toggle Navigation"
      }, _hoisted_4)
    ]),
    _hoisted_5
  ]))
}